import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import Icon from './Icon';
import ProfilePdfBatchUpload from './ProfilePdfBatchUpload';
import './RelationshipManagers.css';
import './ProfilePdfImportDialog.css';

/**
 * "Add people from PDFs": LinkedIn profile PDFs of people at any company. Each is matched against
 * everyone on file, or added as a new person at the PDF's current employer.
 */
const ProfilePdfImportDialog = ({ isOpen, onClose, onDataChanged }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (isOpen) dialogRef.current?.focus();
  }, [isOpen]);

  // Escape closes the dialog; it doesn't reach the panels underneath
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      event.stopPropagation();
      onClose();
    };
    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <>
      <div className="rm-overlay" onClick={onClose} aria-hidden="true" />
      <div className="rm-dialog pdf-import-dialog" role="dialog" aria-modal="true" aria-labelledby="pdf-import-title"
           ref={dialogRef} tabIndex={-1}>
        <header className="rm-dialog__header">
          <div>
            <h2 id="pdf-import-title"><Icon name="upload" /> Add people from PDFs</h2>
            <p>
              LinkedIn profile PDFs (More &gt; Save to PDF on a profile) of people at any company. Each is matched
              to the person on file, or added as a new person at their current employer.
            </p>
          </div>
          <button type="button" className="rm-icon-button" onClick={onClose} aria-label="Close">
            <Icon name="x" />
          </button>
        </header>
        <div className="rm-dialog__body pdf-import-dialog__body">
          <ProfilePdfBatchUpload embedded onDataChanged={onDataChanged} />
        </div>
      </div>
    </>,
    document.body
  );
};

export default ProfilePdfImportDialog;
